import script from "./TriadMetronomeBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TriadMetronomeBar.vue?vue&type=script&setup=true&lang=js"

import "./TriadMetronomeBar.vue?vue&type=style&index=0&id=f081b8e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f081b8e0"]])

export default __exports__